import { useEffect, useState } from "react";
import { AppLayout } from "../../../layout/AppLayout";
import { AnimatePresence, motion } from "framer-motion";
import { Referrals } from "./Referrals";
import { AboutReferrals } from "./aboutReferrals";
import { FullModal } from "../../../modules/world/rmc/modals/fullModal";
import { CheckedCircle } from "../../svg/GeneralIcons";
import Button from "../../button/Button";
import { useNavigate } from "react-router-dom";
import { Arrow } from "../../svg/Wallet/Wallet";
import { useReferrals } from "../../../api/settings/referrals";

const tabs = [
  {
    name: "referrals",
    label: "Referrals",
    render: (isLoading, referrals) => {
      return <Referrals isLoading={isLoading} referrals={referrals} />;
    },
  },
  {
    name: "earnings",
    label: "Earnings",
    render: () => {
      return <></>;
    },
  },
];

const tabContentVariants = {
  initial: {
    y: 10,
    opacity: 0,
  },
  enter: {
    y: 0,
    opacity: 1,
  },
  exit: {
    y: -10,
    opacity: 0,
  },
};

export const ReferAndEarn = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(tabs[0]);

  const {
    ListReferrals,
    referrals,
    isLoading,
    RedeemReferrals,
    loading,
    isClaimed,
    setIsClaimed,
    claimedPoints,
  } = useReferrals();

  useEffect(() => {
    ListReferrals();
  }, []);
  const handleClick = (e, tab) => {
    e.preventDefault();

    setActiveTab(tab);
  };

  const isSelected = (tab) => activeTab.name === tab.name;
  return (
    <AppLayout bg={"!bg-[#F8F8F8]"}>
      <div className="pt-10">
        <motion.div
          initial={{ opacity: 0, scale: 0.2 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.6,
            ease: [0.25, 0.46, 0.45, 0.94],
          }}
          className="w-full relative flex flex-col flex-grow"
        >
          <div className="container px-4 pb-16 h-full">
            <div className="relative flex items-center justify-center mb-10">
              <Arrow
                onClick={() => navigate(-1)}
                stroke="#fff"
                className="text-lg absolute left-0 cursor-pointer"
              />
              <p className="font-bold text-xl text-black">Refer & Earn</p>
            </div>
            <div className="ach-tabWrapper h-full">
              <div className="ach-tabHeader mx-4">
                {tabs.map((tab) => (
                  <div
                    key={tab.name}
                    className={[
                      "rne-tabItem cursor-pointer",
                      isSelected(tab) ? "ach-selected" : "",
                    ].join(" ")}
                  >
                    <span onClick={(e) => handleClick(e, tab)}>
                      {tab.label}
                    </span>

                    {isSelected(tab) && (
                      <motion.div
                        layoutId="indicator"
                        className={"ach-indicator"}
                      />
                    )}
                  </div>
                ))}
              </div>

              <div className={"ach-tabContent, !pt-0"}>
                <AnimatePresence mode="wait">
                  <motion.div
                    key={activeTab.name || "empty"}
                    variants={tabContentVariants}
                    initial="initial"
                    animate="enter"
                    exit="exit"
                    transition={{
                      duration: 0.3,
                    }}
                    className="px-4 pb-3"
                  >
                    <AboutReferrals
                      isLoading={isLoading}
                      points={referrals?.total_referral_point}
                      setIsClaimed={setIsClaimed}
                      loading={loading}
                      RedeemReferrals={RedeemReferrals}
                    />
                    {activeTab &&
                      activeTab?.render(
                        isLoading,
                        referrals,
                        loading,
                        RedeemReferrals
                      )}
                  </motion.div>
                </AnimatePresence>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
      <AnimatePresence>
        {isClaimed && (
          <FullModal className="fixed h-full inset-x-0 bottom-0 z-[4000] bg-[#F8F8F8] animate-slide-up 480:max-w-[440px] 480:mx-auto ">
            <div className="pt-16 pb-7 px-5 min-h-screen flex flex-col">
              <div className="w-full relative flex flex-col flex-grow">
                <div className="relative flex items-center justify-center mb-10">
                  <p className="font-bold text-xl text-black">Claim Points</p>
                </div>
                <div className=" flex-grow flex justify-between items-center flex-col h-full gap-5">
                  <div className="flex-grow flex items-center flex-col w-full ">
                    <CheckedCircle />
                    <div className="my-12 mb-7 text-center">
                      <p className="text-black text-3xl font-semibold">
                        Success!
                      </p>
                      <p className="text-lg text-black font-medium">
                        Points claimed successfully
                      </p>
                    </div>

                    <div className=" w-full  border border-[#0000004D] bg-white rounded-md px-3.5 pb-4 pt-3.5 font-semibold text-4xl text-center">
                      {claimedPoints} pts
                    </div>
                  </div>
                  <div className="mt-4 w-full">
                    <Button
                      onClick={() => navigate("/achievements?tab=redeem")}
                      text="View Points"
                    />
                  </div>
                </div>
              </div>
            </div>
          </FullModal>
        )}
      </AnimatePresence>
    </AppLayout>
  );
};
